const Style = (theme) => ({
  vehicle__info__bar: {
    // marginLeft: '1.5rem',
  },

  add__btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    height: '100%',
    borderRadius: '1000px',
    background: 'rgba(105, 33, 196, 0.2)',
    color: '#6921C4',
    width: '143px',
    '&:hover': {
      background: 'rgba(105, 33, 196, 0.2)',
    },
    [theme.breakpoints.between(960, 1130)]: {
      width: '106px',
      fontSize: '12px',
      '& svg': {
        height: ' 17px',
        width: ' 17px',
        padding: ' 1px',
        marginBottom: ' 2px',
      },
    },
  },

  dropdown__main: {
    position: 'absolute',
    top: '3.5rem',
    width: '40rem',
    borderRadius: '15px',
    background: '#fff',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.04)',
  },

  indicator: {
    bottom: '0px',
    background: '#E1D3F3',
    height: '100%',
    borderRadius: '0',
  },
  tabs__bar: {
    backgroundColor: '#F6F6F8',
    boxShadow: 'none',
    padding: '0',
    zIndex: '10',
    position: 'relative',
    borderRadius: '15px 15px 0 0',
    height: '49px',
    '& .MuiTabs-root': {
      '& .MuiTabScrollButton-root': {
        color: 'rgba(109, 125, 139, 1)',
        borderBottom: '3px solid #CCD2E3',
        opacity: '1 !important',
      },
      '& .MuiTabScrollButton-root.Mui-disabled': {
        color: 'rgba(109, 125, 139, .3)',
      },
      '& .MuiTabs-scroller': {
        borderRadius: '15px 15px 0 0',
        '& .MuiTabs-flexContainer': {
          justifyContent: 'space-between',
          '& .MuiTab-root': {
            width: '33.33%',
            maxWidth: '33.33%',
            textTransform: 'capitalize',
            color: '#6D7D8B',
            opacity: '1',
            // borderBottom: '3px solid #CCD2E3',
            zIndex: 10,
            fontSize: '12px',
            [theme.breakpoints.down('xs')]: {
              minWidth: '8rem',
            },
          },
          '& .Mui-selected': {
            color: 'var(--color-primary)',
          },
        },
      },
    },
  },
  tab__panel: {
    height: 'calc(100% - 48px)',
    maxHeight: 'calc(100vh - 8rem)',
    overflow: 'auto',
  },
  tab__panel__padding: {
    padding: '0.6rem',
  },
  coming__soon: {
    height: '446px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  coming__soon__heading: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '138.34%',
    textAlign: 'center',
    color: '#1b181c',
    margin: '0 6rem',
    padding: '1.4rem 0 .6rem 0',
  },
  coming__soon__para: {
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#263238',
    padding: '1.5rem 0',
  },
  info__icon: {
    height: '80px',
    width: '70px',
    '& circle': {
      strokeWidth: '1.8px',
    },
  },
  main__btn: {
    fontSize: '13px',
    fontWeight: '500',
    borderRadius: '100px',
    height: '38px',
    width: '108px',
    textTransform: 'none',
    boxShadow: 'none',
    color: '#fff',
    background: 'var(--color-primary)',
    '&:hover': {
      boxShadow: 'none',
      background: 'var(--color-primary)',
    },
  },
});
export default Style;
